export class Card {
  private _id: string;
  private _text: string;

  constructor(id: string, text: string) {
    this._id = id;
    this._text = text;
  }

  public get id(): string {
    return this._id;
  }

  public get text(): string {
    return this._text;
  }
}
